/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Deserializable } from '@app/shared/models/deserializable.interface';
import { GridDataResult } from '@progress/kendo-angular-grid';

export class PaginatedResponseMeta implements Deserializable {
  current_page: number;
  from: number;
  last_page: number;
  path: string;
  per_page: number;
  to: number;
  total: number;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}

export class PaginatedResponseLinks implements Deserializable {
  first: string;
  last: string;
  next: string;
  prev: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}

export class PaginatedResponse implements Deserializable {
  data: Array<any>;
  links: PaginatedResponseLinks;
  meta: PaginatedResponseMeta;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.links = new PaginatedResponseLinks().deserialize(input.links);
    this.meta = new PaginatedResponseMeta().deserialize(input.meta);
    return this;
  }

  /**
   * Get GridData for Kendo UI grid
   */
  getGridData(): GridDataResult {
    return <GridDataResult>{
      data: this.data,
      total: this.meta.total,
    };
  }
}
